/*
 * Tracking Event Admin - Subscriptions Management - Add Target Subscriptions Dialog
 *
 * Angular Module: trackerbase-app.views.trackerbase-admin.target-subscriptions-editor-dialog
 * Controller: targetSubscriptionsEditorCtrl
 *
 */

import kendo from "@progress/kendo-ui"; import "kendo.timezones";

import Assert from "tbAssert";

import TrackingTargetDataServiceModule from "../../services/TrackingTargetDataService";
import SubscriptionEditorError from "tbClient/views/trackerbase-admin/SubscriptionEditorError";

const mModalInstance = new WeakMap();

const mTargetSubsToAdd = new WeakMap();
const mTrackingTargetDataSource = new WeakMap();
const mTrackingTargetSelectorOptions = new WeakMap();

class TargetSubscriptionsEditorDialogController {
    constructor($uibModalInstance, TrackingTargetData) {
        Assert.StrictAssert($uibModalInstance != null, "Assertion Failure: Missing Modal Instance Dependency");
        Assert.StrictAssert(TrackingTargetData != null, "Assertion Failure: Missing Tracking Target Data Service Dependency");

        mModalInstance.set(this, $uibModalInstance);

        mTargetSubsToAdd.set(this, []);

        let targetDataSourceParams = {
            serverFiltering: true,
            transport: {
                read: (options) => {

                    let lnQuery = null;

                    if (options.data["filter"] != null) {
                        if (options.data.filter.filters.length > 0) {
                            lnQuery = options.data.filter.filters[0].value.trim();
                        }
                    }

                    if (lnQuery == null) {
                        options.success([]);
                        return;
                    }

                    TrackingTargetData
                        .query({lastName: lnQuery})
                        .$promise
                        .then(
                            (response) => {
                                options.success(response.queryResults);
                            },
                            (errorResponse) => {
                                options.error(errorResponse);
                            }
                        );
                }
            }
        };

        mTrackingTargetDataSource.set(this, new kendo.data.DataSource(targetDataSourceParams));

        mTrackingTargetSelectorOptions.set(this, {
            dataSource: mTrackingTargetDataSource.get(this),
            filter: "startsWith",
            delay: 500,
            dataTextField: "targetName",
            dataValueField: "trackingTargetId"
        });
    }

    get targetSubsToAdd() {
        return mTargetSubsToAdd.get(this);
    }

    set targetSubsToAdd(updatedVal) {
        mTargetSubsToAdd.set(this, updatedVal);
    }

    canAddTargetSubs() {
        return (mTargetSubsToAdd.get(this).length > 0);
    }

    get addTargetSubsSelectorOptions() {
        return mTrackingTargetSelectorOptions.get(this);
    }

    cancel() {
        mModalInstance.get(this).dismiss(SubscriptionEditorError.MakeEditorCancelledResult());
    }

    ok() {
        let selectedTargets = this.targetSubsToAdd.map((tgt) => tgt.trackingTargetId);

        mModalInstance.get(this).close({
            subs: { Target: selectedTargets },
            msgs: []
        });
    }

}

TargetSubscriptionsEditorDialogController.$inject = [
    "$uibModalInstance",
    "TrackingTargetData"
];

TargetSubscriptionsEditorDialogController.dependencies = [
    "ngAnimate",
    "ngSanitize",
    "ui.bootstrap",
    "kendo.directives",
    TrackingTargetDataServiceModule
];

TargetSubscriptionsEditorDialogController.template = require("./TargetSubscriptionsEditorDialog.tpl.html");

TargetSubscriptionsEditorDialogController.controllerAs = "tbTargetSubMgr";

export default TargetSubscriptionsEditorDialogController;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-admin/TargetSubscriptionsEditorDialog.js
// module id = EytC
// module chunks = 1